export const HEADER_CONTENT_DISPOSITION = 'Content-Disposition';
export const NORMALIZED_HEADER_CONTENT_DISPOSITION = 'content-disposition';
export const HEADER_CONTENT_TYPE = 'Content-Type';
export const HEADER_BYPASS_DATA_INTERCEPTOR = 'Kip-Bypass-Data-Interceptor';
